import React, { PureComponent } from "react";
import * as d3 from "d3";
import { downloadCSVData } from "../utils";
import { Scrollbars } from "react-custom-scrollbars";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import NoData from "../NoData/NoData";

import { toggleViewExcludedWords } from "../../../../../actions/dashboardAction";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";

class TopKeywords extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            drilledWords: this.initLocalStorageDrilledWords(),
            showInfo: false,
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.resizedCount !== prevProps.resizedCount) {
            this.renderKeywordRows();
        }
    }

    handleContextMenu(e, keyword, isPositive) {
        if (this.props.isPublic) return;
        let self = this;
        if (!this.props.drilldown_charts) {
            let contextMenu = d3.select(".dashboard-charts-contextmenu");
            e.preventDefault();
            contextMenu.style("top", `${e.clientY}px`);
            contextMenu.style("left", `${e.clientX - 100}px`);
            contextMenu.html(null);

            contextMenu
                .append("li")
                .text("View Conversations")
                .on("click", () => {
                    self.handleContextMenuClick(keyword, isPositive);
                });
            contextMenu
                .append("li")
                .text("View Insights")
                .on("click", () => {
                    // console.log('drilldown')
                    self.handleDrilldownClick(keyword, isPositive);
                    // this.props.showChartsDrilldown(true, "topicWiseSentimentBreakup");
                });
            // contextMenu
            //     .append("li")
            //     .text("View Conversations")
            //     .on("click", () => {
            //         self.getConversations(keyword, isPositive);
            //     });
            // !this.props.drilldown_charts &&
            //     contextMenu
            //         .append("li")
            //         .text("View Insights")
            //         .on("click", () => {
            //             // console.log('drilldown')
            //             this.handleDrilldownClick(cluster_keyword);
            //             this.props.showChartsDrilldown(true, "wordcloud");
            //         });
            contextMenu.style("display", "block");
        }
    }

    getConversations(d, isPositive) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};

        newFilter.extras = newFilter.extras ? newFilter.extras : [];
        newFilter.extras.push({ key: "Drilled Down Words", value: [d] });

        if (isPositive) {
            newFilter.extras.push({ key: "Sentiment", value: "positive" });
        } else {
            newFilter.extras.push({ key: "Sentiment", value: "negative" });
        }
        console.log("firstnewFilter", newFilter);

        return newFilter;
        // this.props.handleContextMenuClick(newFilter);
    }

    handleContextMenuClick = (d, isPositive) => {
        let newFilter = this.getConversations(d, isPositive);
        console.log("firstnewFilter", newFilter);
        this.props.handleContextMenuClick(newFilter);
    };

    handleDrilldownClick(d, isPositive) {
        let newFilter = this.getConversations(d, isPositive);
        console.log("firstnewFilter", newFilter);
        this.props.handleDrilldownClick(newFilter);
    }

    initLocalStorageDrilledWords() {
        let drilledWords = localStorage.getItem("drilledWords");
        if (drilledWords) return JSON.parse(drilledWords);
        return [];
    }

    renderKeywordRows() {
        if (this.props.data != undefined) {
            return this.props.data.map((keyword, ind) => {
                if (ind < 10) {
                    let rowcolor = "#fff";
                    if (ind % 2 != 0) {
                        rowcolor = "#f9f9fc";
                    }
                    return (
                        <tr key={ind} style={{ backgroundColor: rowcolor }}>
                            <td className="skiptranslate" style={{ padding: "5px" }}>
                                {ind + 1}
                            </td>
                            <td style={{ padding: "5px" }}>{keyword.key}</td>
                            <td
                                className="skiptranslate"
                                onContextMenu={(e) => this.handleContextMenu(e, keyword.key, +this.isPositive())}
                                style={{ cursor: "pointer", padding: "5px" }}>
                                {keyword.doc_count}
                            </td>
                        </tr>
                    );
                }
            });
        } else {
            return null;
        }
    }

    renderDownloadButton(nodata) {
        return <DownloadChart nodata={nodata} options={[{ name: "CSV", downloadFn: this.downloadCSV }]} />;
    }

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }
        let csvFmt = [["Number", "Keyword", "Mentions"]];
        this.props.data.forEach((keyword, ind) => {
            if (ind < 10) {
                csvFmt.push([ind + 1, keyword.key, keyword.doc_count]);
            }
        });
        downloadCSVData(csvFmt, this.props.widget.name);
    };

    isPositive = () => (this.props.widget.chart_name === "topKeywordsPositive" ? true : false);

    viewExcludedWords = () => {
        this.props.toggleViewExcludedWords(true);
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.length === 0) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info={`Top Keywords in ${this.props.widget.chart_name === "topKeywordsPositive" ? "Positive" : "Negative"} Conversations.`}
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            !this.props.drilldown_charts &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && !this.props.isResearchDashboard && this.renderDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata
                                    ? null
                                    : !this.props.drilldown_charts && (
                                          <Popup
                                              className="skiptranslate"
                                              trigger={
                                                  this.props.expandWidget ? (
                                                      <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  ) : (
                                                      <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                                  )
                                              }
                                              inverted
                                              content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                              size="mini"
                                              position="bottom center"
                                              style={{ zIndex: "99999" }}
                                          />
                                      )}
                            </>
                        }
                        {!this.props.isPublic && !this.props.drilldown_charts && (
                            <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />
                        )}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!this.props.isPublic && (
                            <div className="menu-option" onClick={this.viewExcludedWords}>
                                <span>View Excluded Words</span>
                            </div>
                        )}
                        {!this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}
                {!nodata ? (
                    <div className="dashboard-chart topkeywords_scrollable">
                        <Scrollbars autoHide id="scroll-div">
                            <table style={{ padding: "3px", textAlign: "center", width: "100%" }}>
                                <tbody>
                                    <tr className="skiptranslate" style={{ padding: "5px", backgroundColor: "#efeff7" }}>
                                        <td style={{ padding: "5px" }}>Number</td>
                                        <td style={{ padding: "5px" }}>Keyword</td>
                                        <td style={{ padding: "5px" }}>Mentions</td>
                                    </tr>
                                    {this.renderKeywordRows()}
                                </tbody>
                            </table>
                        </Scrollbars>
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        drilldown_filters: state.dashboardReducer.drilldown_filters,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

const mapDispatchToProps = (dispatch) => ({
    toggleViewExcludedWords: (data) => dispatch(toggleViewExcludedWords(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopKeywords);
